import { defineComponent as _defineComponent } from 'vue'
import { SkuLocationList } from "./WavePickAbandon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WavePickTote',
  props: {
  toteName: {
    type: String,
    required: true,
  },
  toteScanned: {
    type: Boolean,
    required: true,
  },
  skuLocationList: {
    type: Array<SkuLocationList>,
    required: false,
  },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})